import { useRef } from "react";

import { Modal as NeetoUIModal } from "neetoui";

import Menu from "./Menu";

const Modal = ({ isOpen, onClose }) => {
  const initialFocusRef = useRef(null);

  return (
    <NeetoUIModal
      {...{ initialFocusRef, isOpen, onClose }}
      backdropClassName="neeto-molecules-product-switcher_modal"
      size="large"
    >
      <NeetoUIModal.Body>
        <div
          className="neeto-molecules-product-switcher_modal-container"
          data-testid="product-switcher-modal"
        >
          <Menu {...{ initialFocusRef }} />
        </div>
      </NeetoUIModal.Body>
    </NeetoUIModal>
  );
};

export default Modal;
